export type AcademyRole =
  | "super_admin"
  | "admin"
  | "content_manager"
  | "curator"
  | "mentor"
  | "manager"
  | "trainee"
  | "guide";

export const ALL_ROLES: AcademyRole[] = [
  "super_admin",
  "admin",
  "content_manager",
  "curator",
  "mentor",
  "manager",
  "trainee",
  "guide",
];

export const ROLE_LABELS: Record<AcademyRole, string> = {
  super_admin: "Super Admin",
  admin: "Admin",
  content_manager: "Методист",
  curator: "Куратор",
  mentor: "Наставник",
  manager: "Менеджер",
  trainee: "Ученик",
  guide: "Гид",
};

export interface UserMe {
  id: number;
  login: string;
  full_name: string;
  phone: string | null;
  telegram_user_id: number | null;
  avatar_file_id: string | null;
  roles: AcademyRole[];
  is_sandbox: boolean;
  password_must_change: boolean;
  last_login_at: string | null;
}

export interface UserListItem {
  id: number;
  login: string;
  full_name: string;
  roles: AcademyRole[];
  is_active: boolean;
  is_sandbox: boolean;
  deleted_at: string | null;
  last_login_at: string | null;
  created_at: string;
}

export interface UserList {
  items: UserListItem[];
  total: number;
  page: number;
  page_size: number;
}

export interface UserDetail extends UserListItem {
  phone: string | null;
  telegram_user_id: number | null;
  password_must_change: boolean;
  updated_at: string;
}



export interface UserCreated {
  user: UserDetail;
  generated_password: string;
}
